import { createSystem, defaultConfig, defineConfig, defineRecipe } from '@chakra-ui/react'

export const adminConfig = defineConfig({
  theme: {
    tokens: {
      fonts: {
        heading: { value: 'Poppins, Arial, sans-serif' },
        body: { value: 'Lato, Arial, sans-serif' },
      },
    },
    recipes: {
      button: defineRecipe({
        className: 'chakra-button',
        defaultVariants: {
          size: 'sm',
        },
      }),
      input: defineRecipe({
        className: 'chakra-input',
        defaultVariants: {
          size: 'sm',
        },
      }),
      nativeSelect: defineRecipe({
        className: 'chakra-select',
        defaultVariants: {
          size: 'sm',
        },
      }),
    },
  },
})

export const adminTheme = createSystem(defaultConfig, adminConfig)
